<template>
  <div >
    <div class="header">
      KLIMA, ENERGIE UND ARTENSCHUTZ
    </div>
    <div class="separator"></div>

      <div class="content programme-block">
        <div class="programme-item">
        <div class="programme-title">UNSERE VISION #WEIDEN2040</div>
        Die dezentrale Energiewende mit Sonne, Wind und Speichern
        ist geschafft, die Stadt ist klimaneutral, artenfreundlich und umgeben
        von einer gesunden Natur- und Kulturlandschaft.
        <br>
        Das erreichen wir durch
        </div>

        <div class="programme-item">
          <div  @click="toggleBlockOne" class="programme-title">
            <i class="fa fa-chevron-right expand-icon" :class="{ expanded : block1 }"></i>
            Wald erhalten und Gewerbegebiet schaffen
          </div>
          <div v-if="block1">
            Beibehaltung des Forstes in
            Weiden West und Schaffung notwendiger Gewerbeflächen durch die
            Nutzung vorhandener Industriebrachen und Stilllegung bzw. Umnutzung des
            Flugplatzes, natürlich unter Beibehaltung des Rettungshubschraubers.
          </div>
        </div>

       <div class="programme-item">
          <div @click="toggleBlockTwo" class="programme-title">
            <i class="fa fa-chevron-right expand-icon" :class="{ expanded : block2 }"></i>
            Erneuerbare Energien massiv ausbauen</div>
          <div v-if="block2">
              Einen umfassenden Ausbau erneuerbarer Energien unter Einbeziehung
              innovativer Speichertechnologien. 
            <br> 
              Wir unterstützen dabei Entwicklungen in
              der Nordoberpfalz im Hinblick auf Zukunftstechnologien, wie z. B. den
              Einsatz von grünem Wasserstoff in der Energieversorgung
            <br>
              den Ausbau von Bürger-Energieanlagen;
            <br>
              Energieeinsparung und Gebäudesanierung;
            <br> den überdimensionierten Ausbau von HGÜ-Trassen lehnen wir ab, weil er
              dem internationalen Handel mit Atom- und Kohlestrom dient und die
              dezentrale Energiewende behindert.
          </div>
     </div>

     <div class="programme-item">
      <div @click="toggleBlockThree" class="programme-title">
        <i class="fa fa-chevron-right expand-icon" :class="{ expanded : block3 }"></i>
        Den städtischen Verkehr optimieren</div>
          <div v-if="block3">
            Eine Minimierung des Pendlerverkehrs und eine lebenswerte, begrünte
            Innenstadt durch stadtplanerisch optimierten Wohnungsbau mit guter
            fußläufiger Durchwegung;
          </div>
     </div>
     <div class="programme-item">

      <div @click="toggleBlockFour" class="programme-title">
        <i class="fa fa-chevron-right expand-icon" :class="{ expanded : block4 }"></i>
        Bauern unterstützenund  Regionale Nahrungsmittel fördern</div>
          <div v-if="block4">
            Den Bezug von regionalen Bioprodukten für alle öffentlichen Kantinen
            in Kliniken, Kindergärten, Schulen und Behörden. Damit einhergend
            den Ausbau regionaler ökologischer Landwirtschaft, die einen
            wesentlichen Beitrag zum Klima- und Artenschutz leisten kann und einem
            damit einhergehenden Beitrag unserer regionalen landwirtschaftlichen
            Betriebe zu unterstützen.
          </div>
     </div>
     <div class="programme-item">
      <div @click="toggleBlockFive" class="programme-title">
        <i class="fa fa-chevron-right expand-icon" :class="{ expanded : block5 }"></i>
        Konsequenter Artenschutz in der Stadt</div>
          <div v-if="block5">
            Den konsequenten Schutz von Bäumen, Sträuchern, Hecken und
            biotopartigen Flächen der Stadt und die Anlage von Blühflächen.
          </div>
     </div>

     <div class="programme-item">
      <div @click="toggleBlockSix" class="programme-title">
        <i class="fa fa-chevron-right expand-icon" :class="{ expanded : block6 }"></i>
        Teilnahme am Energy-Award</div>
          <div v-if="block6">
            Wir wollen, dass sich die Stadt Weiden am European Energy Award
            beteiligt, einem Programm, das die Energiewende auf kommunaler Ebene
            begleitet und voranbringt.
          </div>
     </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Sdg01',
  data() {
    return {
      block1: false,
      block2: false,
      block3: false,
      block4: false,
      block5: false,
      block6: false,
    }
  },
  methods: {
    toggleBlockOne(){
      this.block1 = !this.block1
    },
    toggleBlockTwo(){
      this.block2 = !this.block2
    },
    toggleBlockThree(){
      this.block3 = !this.block3
    },
    toggleBlockFour(){
      this.block4 = !this.block4
    },
    toggleBlockFive(){
      this.block5 = !this.block5
    },
    toggleBlockSix(){
      this.block6 = !this.block6
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared.scss';
